module.exports = __webpack_public_path__ + "img/volume-max.47daf4c3.svg";